import { PaymentFormFieldType, INVALID_ERRORS, REQUIRED_ERRORS } from '../constants';
/**
 * Returns error text for payment field
 */
export var getPaymentFieldErrorText = function getPaymentFieldErrorText(params) {
  var paymentForm = params.paymentForm,
    paymentErrorModal = params.paymentErrorModal,
    error = params.error,
    requiredKey = params.requiredKey,
    invalidKey = params.invalidKey;
  var type = PaymentFormFieldType.ERROR;
  //  add new along with existing structure support from contentful in payment section
  var fieldErrors = (paymentErrorModal === null || paymentErrorModal === void 0 ? void 0 : paymentErrorModal[type]) || (paymentForm === null || paymentForm === void 0 ? void 0 : paymentForm[type]);
  if (error && INVALID_ERRORS.has(error)) {
    var _fieldErrors$find;
    return (fieldErrors === null || fieldErrors === void 0 || (_fieldErrors$find = fieldErrors.find(function (fieldError) {
      return fieldError.uniqueId === invalidKey;
    })) === null || _fieldErrors$find === void 0 ? void 0 : _fieldErrors$find.text) || '';
  } else if (error && REQUIRED_ERRORS.has(error)) {
    var _fieldErrors$find2;
    return (fieldErrors === null || fieldErrors === void 0 || (_fieldErrors$find2 = fieldErrors.find(function (fieldError) {
      return fieldError.uniqueId === requiredKey;
    })) === null || _fieldErrors$find2 === void 0 ? void 0 : _fieldErrors$find2.text) || '';
  }
  return '';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/utils/getPaymentFieldErrorText.js
// module id = 660
// module chunks = 11